<template>
    <div class="credit-card-section">
        <div id="custom-bcmc-container" v-if="readOnly && selectedPaymentMethod.cardData">
            <div class="vue-form">
                <div class="vue-form-row">
                    <div class="vue-form-element">
                        <label>
                            <span class='cardHolderName'>{{holderName}}</span>
                            <span>{{lastFour}}</span>
                            <span>{{expiryDate}}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div id="custom-bcmc-container" v-else>
            <div class="vue-form">
                <div class="vue-form-row">
                    <div class="vue-form-element">
                        <label>
                            <span>{{resources.creditCards.number}}</span>
                            <span v-if="cardNumberInvalid" class="error" id="encryptedCardNumber-error">{{resources.errors.invalidInput}}</span>
                            <div data-cse="encryptedCardNumber" class="input-wrapper">
                                <img class="brand-logo" :src="brandImageUrl" />
                            </div>
                        </label>
                    </div>
                </div>

                <div class="vue-form-row has-multiple-elements">
                    <div class="vue-form-element">
                        <label>
                            <span>{{resources.creditCards.expiryDate}}</span>
                            <span v-if="expiryDateInvalid" class="error" id="encryptedExpiryDate-error">{{resources.errors.invalidInput}}</span>
                            <div data-cse="encryptedExpiryDate" class="input-wrapper"></div>
                        </label>
                    </div>
                </div>

                <div class="vue-form-row">
                    <div class="vue-form-element half-width">
                        <label>
                            <span>{{resources.creditCards.holderName}}</span>
                            <span v-if="holderNameInvalid" class="error" id="cardHolderName-error">{{resources.errors.invalidInput}}</span>
                            <input type="text" id="cardHolderName" @keypress="allowNonNumbersOnly" @change="updatePaymentData"/>
                        </label>
                    </div>
                </div>

                <div class="vue-form-row no-label" v-show="isMember">
                    <div class="vue-form-element">
                        <div class="vue-form-group">
                            <div class="vue-form-group-item">
                                <input type="checkbox" class="vue-input vue-input-checkbox" id="saveCreditCard" @change="updatePaymentData"/>
                                <label for="saveCreditCard">{{resources.creditCards.saveCard}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script src='./bancontact-cards.js'></script>
